import * as React from "react";
const SvgFiRrFlyInsect = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-fly-insect_svg__a)">
      <path
        fill="#062147"
        d="M16.497 7.127c0-.021 0-.01 0 0m-8.995-.002c-.001-.021 0-.01 0 0m16.495 7.821a4.16 4.16 0 0 1-1.322 2.921 4.18 4.18 0 0 1-2.864 1.131 4.18 4.18 0 0 1-3.058-1.322c-.09-.096-.248-.265-.572-.753C15.45 20.783 14.35 24 11.999 24s-3.453-3.218-4.183-7.079a7 7 0 0 1-.367.52 4.19 4.19 0 0 1-3.265 1.557 4.17 4.17 0 0 1-2.627-.927 4.195 4.195 0 0 1-.63-5.892c.695-.86 3.309-3.515 6.574-5.055 0 .01 0 .02 0 0 0-1.191.654-2.425 1.652-3.171a3 3 0 1 1 5.689 0c.998.747 1.652 1.982 1.652 3.174 0 .011 0 .021 0 0 3.004 1.43 5.427 3.813 6.369 4.818a4.16 4.16 0 0 1 1.13 3.001zm-14.622-5a5.7 5.7 0 0 1-1.087-.981c-2.687 1.287-5.037 3.521-5.804 4.47-.758.939-.61 2.32.329 3.079.94.758 2.32.61 3.079-.329.218-.27.987-1.416 3.482-6.239M13.335 20h-2.671c.652 1.86 1.19 2 1.336 2s.683-.14 1.336-2zm.98-4H9.683c.137.758.275 1.421.412 2h3.808c.137-.579.275-1.242.412-2m.163-2c-.452-.832-.995-1.857-1.645-3.123a2.87 2.87 0 0 1-1.685-.005q-.931 1.8-1.651 3.128zm.02-7c0-.925-1.091-2-2.5-2-1.407 0-2.5 1.075-2.5 2 0 .665 1.11 1.491 2.155 1.93a.88.88 0 0 0 .692 0c1.044-.439 2.154-1.265 2.154-1.93m6.909 6.313c-.668-.712-2.95-3.014-5.698-4.346-.31.368-.688.7-1.1.989 2.64 5.136 3.423 6.158 3.604 6.351a2.192 2.192 0 0 0 3.786-1.427 2.18 2.18 0 0 0-.591-1.568z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-fly-insect_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFlyInsect;
